import React from "react";
import { Box } from "@mui/material";

const BankDetailsNotice = ({ data }) => {
  console.log({data})
  return (
    <Box
      sx={{
        backgroundColor: "#FFF8E1",
        padding: "10px",
        borderRadius: "4px",
        border: "1px solid #FFEB3B",
        marginBottom: "20px",
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: data }}></div>
    </Box>
  );
};

export default BankDetailsNotice;
